import { gold } from "@ant-design/colors"
import ThemableButton from "../../Items/ThemableButton"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEnvelopeOpenDollar } from "@fortawesome/pro-solid-svg-icons"
import { getBestCustomerEmail } from "../../../domain/customers/customer"
import { hasValue } from "../../../helpers/nullable"
import { Tooltip } from "antd"
import { useContext } from "react"
import JobInvoicingContext from "../JobInvoicingContext"

type Props = {
  controlsDisabled: boolean
  invoiceId: string
  onSendInvoice?: () => void
}

const SendInvoiceButton = ({ invoiceId, controlsDisabled, onSendInvoice }: Props) => {
  const { setActiveInvoicingModal, customerEmails } = useContext(JobInvoicingContext)
  const hasEmail = hasValue(getBestCustomerEmail(customerEmails))

  const disabled = controlsDisabled || !hasEmail

  const button = <ThemableButton
    type="primary"
    colorPrimary={gold.primary}
    icon={<FontAwesomeIcon icon={faEnvelopeOpenDollar}/>}
    disabled={disabled}
    onClick={() => {
      setActiveInvoicingModal({ modal: 'sendInvoice', invoiceId })
      onSendInvoice?.()
    }}
  >
    Send Invoice
  </ThemableButton>

  return hasEmail ? button : <Tooltip title="No email found for this customer">{button}</Tooltip>
}

export default SendInvoiceButton